const ZakyamLogo = ({ className }: { className?: string }): JSX.Element => (
  <svg
    className={className}
    viewBox="0 0 400 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Zakyam AI Trader"
    fill="none"
  >
    <defs>
      <linearGradient id="zakyamTextGradient" x1="0" y1="0" x2="400" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#5BE0FF" />
        <stop offset="50%" stopColor="#4CA4FF" />
        <stop offset="100%" stopColor="#7B5BFF" />
      </linearGradient>
    </defs>
    <text
      x="8"
      y="58"
      fontFamily="'Segoe UI', system-ui, -apple-system, sans-serif"
      fontSize="52"
      fontWeight="700"
      fill="url(#zakyamTextGradient)"
      letterSpacing="-0.5"
    >
      Zakyam
    </text>
    <text
      x="220"
      y="64"
      fontFamily="'Segoe UI', system-ui, -apple-system, sans-serif"
      fontSize="14"
      fontWeight="600"
      fill="rgba(148, 163, 184, 0.7)"
      letterSpacing="2.5"
    >
      AI TRADER
    </text>
  </svg>
);

export default ZakyamLogo;
